import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { onAuthStateChanged } from 'firebase/auth';
import { BASE_URL } from '../url';
import { database } from '../config';
import SiteLayout, { PageHero } from './SiteLayout';
import LoadingSpinner from './LoadingSpinner';

function PostNews() {
  const [imageURL, setImageURL] = useState('');
  const [postHeading, setPostHeading] = useState('');
  const [postDetails, setPostDetails] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [loggedIn, setLoggedIn] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const checkLoggedIn = onAuthStateChanged(database, (authUser) => {
      setLoggedIn(authUser || null);
      setAuthChecked(true);
    });
    return () => checkLoggedIn();
  }, []);

  function createNewPost(ev) {
    ev.preventDefault();
    axios.post(`${BASE_URL}/post`, { imageURL, postHeading, postDetails }).then((response) => {
      if (response.status === 200) {
        setRedirect(true);
      }
    });
  }

  if (redirect) {
    alert('News Added Successfully!');
    window.location.href = '/news';
  }

  return (
    <SiteLayout>
      <main>
        <PageHero eyebrow="Admin" title="Create news post">
          Share a new Raising Smiles update with the community.
        </PageHero>
        <section className="section-padding admin-section">
          <div className="container">
            {!authChecked && <LoadingSpinner compact />}
            {authChecked && !loggedIn && (
              <div className="empty-state">
                <h2>Login required</h2>
                <p>You are unauthorized to view this page. Please login to continue.</p>
                <Link to="/login" className="btn btn-primary-rs">Login</Link>
              </div>
            )}
            {authChecked && loggedIn && (
              <form onSubmit={createNewPost} className="custom-form modern-form admin-form">
                <h2>Create new post</h2>
                <label htmlFor="post-image">Image URL</label>
                <input type="url" value={imageURL} onChange={(ev) => setImageURL(ev.target.value)} id="post-image" className="form-control" placeholder="Google Drive image URL" required />
                <label htmlFor="post-heading">Post heading</label>
                <input type="text" value={postHeading} onChange={(ev) => setPostHeading(ev.target.value)} id="post-heading" className="form-control" placeholder="Post heading" required />
                <label htmlFor="post-details">Post details</label>
                <textarea value={postDetails} onChange={(ev) => setPostDetails(ev.target.value)} rows="7" className="form-control" id="post-details" placeholder="Post details" required></textarea>
                <button type="submit" className="form-control">Submit Post</button>
              </form>
            )}
          </div>
        </section>
      </main>
    </SiteLayout>
  );
}

export default PostNews;
